module.exports = __webpack_public_path__ + "static/img/Keanu-Pinder.1a380bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Keanu-Pinder.jpg
// module id = 38z+
// module chunks = 1